import { EVENTS_MAPPING } from '../constants';
import removeEmptyEntries from '../../../shared/utils/removeEmptyEntries';
import mixpanelService from '../../../shared/services/mixPanel';
import localStorage from './localStorage';

const prepareMixpanelTrackPayload = ({ categoryId, title, payload = {} }) => removeEmptyEntries({
    'Page Name': 'Category',
    'Category Id': categoryId,
    'Category Name': title,
    ...payload
});

class Tracker {

    initialize(context) {

        this.context = context;
    }

    trackHowFiverrWorksVideo(payload) {
        mixpanelService.trackEvent(
            EVENTS_MAPPING.CLICK.TARGETS.HOW_FIVERR_WORKS_VIDEO,
            prepareMixpanelTrackPayload({ ...this.context, payload })
        );
    }

    view(categorySlug, title, loggedIn) {
        mixpanelService.trackEvent(
            EVENTS_MAPPING.PAGE_VIEWED.mixpanel,
            prepareMixpanelTrackPayload({ ...this.context })
        );
        !loggedIn && localStorage.storePageView(categorySlug);
    }
}

export default new Tracker();
